module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wtm-ygg-gaming.b688165e.png";